export default __webpack_public_path__ + "static/media/dairy-product.ef8080b3.svg";